document.addEventListener('DOMContentLoaded', function () {
    popupSliderInit();
    initCollectionSlider();
    initProductImageSlider();
    window.addEventListener('recommendedInitialized', popupSliderInit);
    window.addEventListener('aftercollectionform', popupSliderInit);
    window.addEventListener('shopify:section:load', initCollectionSlider);
    window.addEventListener('shopify:section:load', popupSliderInit);
    window.addEventListener('shopify:section:load', initProductImageSlider);

    function initCollectionSlider() {
        if( document.querySelectorAll('.collection-slider').length > 0 ) {
            var sliders = document.querySelectorAll('.collection_splide');
            if( sliders.length > 0 ) {
                sliders.forEach( function(slider) {
                    slider.classList.add( 'splide-inited' );
                    var sliderObj = new Splide( slider , {
                        type   : 'loop',
                        perPage: 3,
                        perMove: 1,
                        lazyLoad: 'nearby',
                        gap: 5,
                        breakpoints: {
                            1023: {
                                perPage: 2,
                            },
                            479: {
                                perPage: 1,
                            },
                        },
                    } );
                    var perBar = sliderObj.root.querySelector( '.my-slider-progress-bar' );
                    // Update the bar width:
                    sliderObj.on( 'mounted move', function ( s ) {
                        var end = sliderObj.Components.Controller.getEnd() + 1;
                        perBar.style.width = String( 100 * ( sliderObj.index + 1 ) / end ) + '%';
                    } );
                    sliderObj.mount();
                } )
            }
        }
    }
    function initProductImageSlider() {
        if( document.querySelectorAll('.product-section').length > 0 ) {
            var mediaWraps = document.querySelectorAll('.product__media-wrapper');
            if( mediaWraps.length > 0 ) {
                mediaWraps.forEach( function(mediaWrap) {
                    if(mediaWrap.querySelectorAll('#main-slider').length > 0) {
                        var sliderObj = new Splide( '#main-slider' , {
                            type       : 'slide',
                            heightRatio: 1,
                            pagination : false,
                            arrows     : false,
                            cover      : true,
                            video      : {
                                loop: true,
                              },
                        } );
                    }
                    if(mediaWrap.querySelectorAll('#thumbnail-slider').length > 0) {
                        var sliderNavObj = new Splide( '#thumbnail-slider' , {
                            rewind          : true,
                            isNavigation    : true,
                            focus           : 'center',
                            pagination      : false,
                            cover           : true,
                            padding         : '50px',
                            breakpoints : {
                                479: {
                                    padding: '30px',
                                }
                            },
                        } );
                    }
                    if(mediaWrap.querySelectorAll('#main-slider').length > 0 && mediaWrap.querySelectorAll('#thumbnail-slider').length > 0) {
                        sliderObj.sync( sliderNavObj );
                    }
                    if(mediaWrap.querySelectorAll('#main-slider').length > 0) {
                        sliderObj.mount();
                    }
                    if(mediaWrap.querySelectorAll('#thumbnail-slider').length > 0) {
                        sliderNavObj.mount();
                    }
                } )
            }
        }
    }
    function popupSliderInit() {
        if( document.querySelectorAll('.select_options_wrap').length > 0 ) {
            var mediaWraps = document.querySelectorAll('.select_options_wrap:not(.inited)');
            if( mediaWraps.length > 0 ) {
                mediaWraps.forEach( function(mediaWrap) {
                    mediaWrap.classList.add( 'inited' );
                    var mainSliderObj = mediaWrap.querySelector('.main-slider');
                    if(document.querySelectorAll('.main-slider').length > 0) {
                        var sliderObj = new Splide( mainSliderObj , {
                            type       : 'slide',
                            heightRatio: 1,
                            height     : '100%',
                            pagination : false,
                            arrows     : false,
                            cover      : true,
                            video      : {
                                loop: true,
                              },
                        } );
                    }
                    var thumbSliderObj = mediaWrap.querySelector('.thumbnail-slider');
                    if(mediaWrap.querySelectorAll('.thumbnail-slider').length > 0) {
                        var sliderNavObj = new Splide( thumbSliderObj , {
                            type            : 'slide',
                            rewind          : true,
                            isNavigation    : true,
                            focus           : 'center',
                            pagination      : false,
                            cover           : true,
                            padding         : '50px',
                            breakpoints : {
                                479: {
                                    padding: '30px',
                                }
                            },
                        } );
                    }
                    if(mediaWrap.querySelectorAll('.main-slider').length > 0 && mediaWrap.querySelectorAll('.thumbnail-slider').length > 0) {
                        sliderObj.sync( sliderNavObj );
                    }
                    if(mediaWrap.querySelectorAll('.main-slider').length > 0) {
                        sliderObj.mount();
                    }
                    if(mediaWrap.querySelectorAll('.thumbnail-slider').length > 0) {
                        sliderNavObj.mount();
                    }
                } )
            }
        }
    }
})